import BannerAward2024 from '../img/banner/Award2024.png';
import Title_Section1 from '../img/event/2511/title.png';
import Online_Session from '../img/event/2511/online-session.png';

import icon_flash from '../img/event/2511/icon-flash.png';
import icon_clock from '../img/event/2511/icon-clock.png';
import icon_money from '../img/event/2511/icon-money.png';

import { DoubleLineWithCursorButton, DoubleLineButton } from './common/Button';
import { TextBox } from './common/TextBox';
const HomeschoolEvent202511 = () => {
  return (
    <>
      {/* 배너 영역 */}
      <img src={BannerAward2024} alt="Award2024" className="m-auto w-full" />
      {/* 프로모션 섹션 1 */}
      {/* 대지 */}
      <div className="flex items-center justify-center overflow-hidden bg-[#FF9D00]">
        {/* 2. 실제 컨텐츠 레이어 : 배경 레이어 위에 표시됨 */}
        <div className="m-auto flex max-w-[720px] flex-col gap-5 px-5 py-14 sm:gap-20 sm:py-20">
          {/* 타이틀 섹션 */}
          <div className="flex flex-col items-center justify-center gap-5 sm:gap-12">
            {/* 타이틀 - 이미지 */}
            <div className="m-auto flex max-w-[276px] flex-col sm:max-w-[360px] md:max-w-[400px]">
              <img
                src={Title_Section1}
                alt="감사로 여는 새해 준비의 골든타임"
              />
            </div>
            <div className="text-md bg-[#F26A24] px-4 py-1 text-center font-bold text-white sm:text-2xl">
              지금 시작하면,
              <br className="sm:hidden" />
              2026년 새학기 시작이 다르다!
            </div>
            <div className="text-center text-lg font-medium text-black sm:text-2xl">
              가정ㆍ교회ㆍ공부방ㆍ대안학교에서
              <br /> 하나의 콘텐츠로
              <br className="sm:hidden" />
              <span className="font-bold">영어와 신앙을 함께 만들어갑니다</span>
            </div>
          </div>
        </div>
      </div>

      {/* 프로모션 섹션 2 */}
      {/* 대지 */}
      <div className="flex items-center justify-center overflow-hidden bg-[#F26A24]">
        {/* 2. 실제 컨텐츠 레이어 : 배경 레이어 위에 표시됨 */}
        <div className="m-auto flex max-w-[720px] flex-col gap-5 px-5 py-14 sm:gap-12 sm:py-20">
          {/* 타이틀 */}
          <div className="text-center text-2xl font-bold text-white sm:text-4xl">
            아래 3가지를 모두 놓치지 마세요!
          </div>

          {/* 말풍선 섹션 */}
          <section className="mx-auto flex flex-col items-center justify-center gap-3 text-lg font-semibold sm:gap-5">
            {/* 말풍선 1 */}
            <div className="flex w-fit items-center gap-6 rounded-2xl bg-[#F3F2E1] px-6 py-4 sm:rounded-3xl sm:px-10 sm:py-5">
              <img
                src={icon_flash}
                alt="icon_flash"
                className="h-8 w-8 sm:h-12 sm:w-12"
              />
              <p className="text-center text-base font-semibold sm:text-lg">
                12월 초{' '}
                <span className="font-bold">‘온라인 컨퍼런스‘ 무료 참석</span>
                <br />
                <span className="font-bold">홈스쿨 회원</span>
                만을 위한 역량강화 교육
              </p>
            </div>
            <div className="flex w-fit items-center gap-6 rounded-2xl bg-[#F3F2E1] px-6 py-4 sm:rounded-3xl sm:px-10 sm:py-5">
              <img
                src={icon_clock}
                alt="icon_clock"
                className="h-8 w-8 sm:h-12 sm:w-12"
              />
              <p className="text-center text-base font-semibold sm:text-lg">
                겨울방학 집중 학습
                <br className="sm:hidden" />→ 신학기 전 젭스 습관 완성!
                <br />
                <span className="font-bold">루틴 정착의 최적기</span>
              </p>
            </div>
            <div className="flex w-fit items-center gap-6 rounded-2xl bg-[#F3F2E1] px-6 py-4 sm:rounded-3xl sm:px-10 sm:py-5">
              <img
                src={icon_money}
                alt="icon_money"
                className="h-8 w-8 sm:h-12 sm:w-12"
              />
              <p className="text-center text-base font-semibold sm:text-lg">
                <span className="font-bold">
                  2026년 인상 전 최대 할인 혜택!
                </span>
                <br />
                지금 등록하면 내년보다 저렴하게
              </p>
            </div>
          </section>

          {/* 설명회 섹션 */}
          <div className="m-auto flex max-w-[480px] flex-col gap-5">
            {/* 타이틀 */}
            <section className="flex flex-col text-center sm:gap-1">
              {/* 서브타이틀 텍스트 */}
              <div className="text-xl font-semibold text-[#FFD75F] sm:text-2xl">
                젭스홈스쿨의 A-Z까지 한 눈에!
              </div>
              {/* 타이틀 텍스트 */}
              <div className="text-2xl font-extrabold text-white sm:text-4xl">
                어디서든 시청할 수 있는 설명회
              </div>
            </section>

            {/* 이미지 */}
            <div className="relative m-auto w-full">
              <img src={Online_Session} alt="젭스영어성경홈스쿨 온라인설명회" />
            </div>

            {/* 버튼 */}
            <DoubleLineButton
              onClick={() => {
                window.open('https://forms.gle/hYg6Q4YQ4tMcBFb58');
              }}
              borderColor="border-white"
              bgColor="bg-black"
              hoverBgColor="hover:bg-black/70"
              textColor="text-white"
            >
              <div className="p-3 text-xl font-bold sm:p-5 sm:text-4xl">
                지금 설명회 신청하기
              </div>
            </DoubleLineButton>
          </div>
        </div>
      </div>

      {/* 프로모션 섹션 3 */}
      <div className="flex items-center justify-center bg-[#FF9D00]">
        {/* 2. 실제 컨텐츠 레이어 : 배경 레이어 위에 표시됨 */}
        <div className="m-auto flex max-w-[720px] flex-col gap-5 px-5 py-14 sm:gap-12 sm:py-20">
          {/* 타이틀 영역 */}
          <div className="flex flex-col items-center justify-center gap-5">
            {/* 타이틀 */}
            <p className="text-center text-2xl font-extrabold text-black sm:text-4xl">
              더 중요한 건,
              <br /> 🌟우리 아이의 골든타임! 🌟
            </p>
            {/* 서브타이틀 */}
            <p className="text-md text-center font-medium text-black sm:text-2xl">
              젭스를 찾아오신 것은 결코 우연이 아닙니다.
              <br /> 지금 이 순간은 우리 아이에게
              <br className="sm:hidden" /> 정말 중요한 시간입니다.
            </p>
          </div>
          {/* 박스 */}
          <section className="flex w-full flex-col gap-5 sm:gap-8">
            <TextBox>
              <div className="w-fit rounded-full bg-[#F26A24] px-8 py-1 text-base font-bold text-white sm:text-lg">
                ⏰ 언어 학습의 골든타임
              </div>
              <p className="font-normal text-black">
                시험용 영어를 시작하기 전,
                <br /> 언어로서 영어를 자연스럽게 받아들이는 시기
                <br />
                <span className="font-bold text-[#EB5D1A]">
                  → 이 시기를 놓치면 문법 암기로 고생합니다.
                </span>
              </p>
            </TextBox>
            <TextBox>
              <div className="w-fit rounded-full bg-[#F26A24] px-8 py-1 text-base font-bold text-white sm:text-lg">
                ⏰ 신앙 습관의 골든타임
              </div>
              <p className="font-normal text-black">
                자녀가 부모의 말에 귀 기울이고
                <br /> 함께 시간 보내는 걸 좋아하는 시기
                <br />
                <span className="font-bold text-[#EB5D1A]">
                  → 이 순간이 지나면 신앙도 ‘나중 일'이 됩니다.
                </span>
              </p>
            </TextBox>
            <TextBox>
              <div className="w-fit rounded-full bg-[#F26A24] px-8 py-1 text-base font-bold text-white sm:text-lg">
                ⏰ 공부 습관 형성의 골든타임
              </div>
              <p className="font-normal text-black">
                하루 30분, 반복 루틴으로 새학기를 위한
                <br /> 공부 습관을 다잡는 시기.
                <br />
                <span className="font-bold text-[#EB5D1A]">
                  → 지금 만든 습관은 평생 자산입니다.
                </span>
              </p>
            </TextBox>
          </section>

          {/* 버튼 */}
          <DoubleLineWithCursorButton
            onClick={() => {
              window.open('https://jebs.kr/shop/details/NKyRTHjIgiewcumT');
            }}
            bgColor="bg-black"
            hoverBgColor="hover:bg-black/70"
            textColor="text-white"
          >
            <div className="p-3 text-xl font-bold sm:p-5 sm:text-4xl">
              11월 등록 혜택 확인
            </div>
          </DoubleLineWithCursorButton>
        </div>
      </div>
    </>
  );
};

export default HomeschoolEvent202511;
